import { Chip } from '@material-ui/core'
import React from 'react'

export default function Tags({ tagsArr }) {
  return tagsArr.map(tag => (
    <Chip style={{ marginRight: 6 }} key={tag} label={`#${tag}`} />
  ))
}
